import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import VueGtag from "vue-gtag";

const app = createApp(App)
app.use(router)

app.use(VueGtag, {
  config: {id: "G-2WK6HDW0CQ"}
}, router)

app.mount('#app')
